import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustFeatures = [
    {
      icon: 'Shield',
      title: 'HIPAA Compliant',
      description: 'Your data is protected with enterprise-grade security'
    },
    {
      icon: 'CheckCircle2',
      title: 'Admin Verification',
      description: 'All accounts undergo thorough credential review'
    },
    {
      icon: 'Clock',
      title: '24-48 Hour Approval',
      description: 'Quick verification process for licensed professionals'
    },
    {
      icon: 'Award',
      title: 'Evidence-Based',
      description: 'Recommendations based on iRefer clinical guidelines'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
          <Icon name="ShieldCheck" size={20} color="var(--color-success)" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Why Register?</h3>
          <p className="text-sm text-muted-foreground">Trusted by healthcare professionals</p>
        </div>
      </div>
      <div className="space-y-4">
        {trustFeatures?.map((feature, index) => (
          <div key={index} className="flex items-start gap-3 p-3 bg-muted/30 rounded-lg">
            <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
              <Icon name={feature?.icon} size={16} color="var(--color-primary)" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">{feature?.title}</p>
              <p className="text-xs text-muted-foreground mt-1">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-primary/5 border border-primary/20 rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={18} color="var(--color-primary)" className="mt-0.5" />
          <div>
            <p className="text-sm font-medium text-primary">Approval Process</p>
            <p className="text-xs text-muted-foreground mt-1">
              After submission, our admin team will verify your credentials. You'll receive an email notification once your account is approved. This typically takes 24-48 hours.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;